<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row>
        <v-col
          v-for="(file, index) in files"
          :key="index"
          cols="12"
          xs="12"
          sm="6"
          md="6"
        >
          <v-card class="mx-auto" max-width="300px" >
            <v-card-text>
              <span class="title">{{ file.title }}</span>
              <v-img :src="imageSrc(file.filename)" @click="enlarge(file.filename)" height="200"></v-img>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="markVisible(file)" outlined rounded :class="file.visibility ? 'green lighten-3' : 'red lighten-4'">
                <label for v-if="file.visibility">
                  <v-icon left>mdi-eye-outline</v-icon>I am public
                </label>
                <label for v-else>
                  <v-icon left>mdi-eye-off</v-icon>I am hidden
                </label>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn outlined small fab color="red" @click="deleteFile(file.id)">
                <v-icon left>mdi-delete</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <Fullscreen ref="full"/>
    <ViewPDF ref="thepdf" />
  </v-main>
</template>

<script>
import Fullscreen from "./ImageFullScreen";
import ViewPDF from "./FileViewPDF"
import { mapGetters } from "vuex";
export default {
  name: "fileComp",
  data: () => ({
    dialog: false,
    valid: true,
    
  }),
  created() {
    this.$store.dispatch("files/aAll");
  },
  components: {
    Fullscreen, ViewPDF
  },
  computed: {
    ...mapGetters("files", {
        files: "gAll"
      }
    )
  },
  methods: {
    enlarge(img) {
      console.log(img)
      if (img.includes(".pdf")) {
        this.$refs.thepdf.openDialog(img)
      } else {
        this.$refs.full.enlarge(img);
      }
      
    },
    imageSrc(img) {
      if(img.includes("/uploads/files/file")) {
        return "https://api.mi-sos.org/uploads/images/sample_pdf.png"
      } else {
        return img
      }
    },
    closeFull() {
      this.fullscreen =  false;
    },
    markVisible(med) {
      //this.show();
      const newMed = {
        visibility: !med.visibility
      };
      const id = med.id;
      //update at the database
      this.$store.dispatch("files/aUpdate", { visibility: newMed, id: id });
    },
    deleteFile(med) {
      this.$store.dispatch("files/aDelete", med);
    },
    /* imageSrc(chartName) {
      return "https://api.mi-sos.org/storage/uploads/files/" + chartName;
    }, */
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("user/aAddProfile", this.profile).then(res => {
          if (res) {
            this.dialog = false;
          }
        });
      }
    }
  }
};
</script>

<style>
  .full-image {
    position:fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left:0;
    background-color: rgba(230, 229, 191, 0.87);
  }
</style>